import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ReportRadinoUseCaseInterface } from 'domain/usecases';

export class RemoteReportRadino implements ReportRadinoUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ReportRadinoUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ReportRadinoUseCaseInterface.Params,
  ): Promise<ReportRadinoUseCaseInterface.Result> {
    const {
      type: reportType,
      endsAt,
      roleIds,
      startsAt,
      semesterIds,
      courseHashIds,
      organizationHashIds,
    } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${reportType}`, {
        ['organizationHashIds[]']: organizationHashIds,
        ['courseHashIds[]']: courseHashIds,
        ['semesterIds[]']: semesterIds,
        ['startsAt']: startsAt,
        ['endsAt']: endsAt,
        ['roleIds[]']: roleIds,
      }),
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
